import React, { ChangeEvent } from 'react'
import { FieldNames } from '../../../types/publishSchedule'
import { setFieldValue } from '../../../actions/publishSchedule'
import { getValueIfPositiveInteger } from '../../../services/publishSchedule'
import { usePublishSchedule } from '../hooks'
import { StyledTextField } from '../styled'

export const Occurrence = () => {
  const [{ fieldValues, fieldErrors }, dispatch] = usePublishSchedule()
  return (
    <StyledTextField
      id="occurrences-input"
      label="Occurrences"
      margin="dense"
      type="number"
      value={fieldValues[FieldNames.occurrences] || ''}
      error={!!fieldErrors[FieldNames.occurrences]}
      helperText={fieldErrors[FieldNames.occurrences]}
      onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
        dispatch(setFieldValue(FieldNames.occurrences, (getValueIfPositiveInteger(value))))
      }}
    />
  )
}
